import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'send-license-details',
    initialState: {
        isSent: '',
        statusAction: 'READY',
    },
    actions: ['SEND_LICENSE_DETAILS'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {
            case types.SEND_LICENSE_DETAILS_SUCCESS:
                return {
                    ...state,
                    isSent: action.payload.isSent
                };
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        sendLicenseDetailsRequest: (pk, email) => ({
            type: types.SEND_LICENSE_DETAILS_REQUEST,
            payload: { pk, email },
        }),
        sendLicenseDetailsSuccess: ({ isSent }) => ({
            type: types.SEND_LICENSE_DETAILS_SUCCESS,
            payload: { isSent },
        }),
        sendLicenseDetailsFailed: error => ({ type: types.SEND_LICENSE_DETAILS_FAILED, error: true, payload: { error } }),
    }),
});
